import { useParams } from 'react-router-dom';
import { Container, Spinner, Alert } from 'react-bootstrap';
import {
  CourseProvider,
  ProgressProvider,
  useAuth,
  useCourseContext,
  useProgressContext,
} from '@context';
import { FlashcardSession } from '@components';
import { canViewCourse } from '@utils/permissions';

function FlashcardsContent() {
  const { course, loading: courseLoading } = useCourseContext();
  const { progress, loading: progressLoading } = useProgressContext();

  if (courseLoading || progressLoading) {
    return (
      <Container className="py-5 text-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  if (!course || !progress) {
    return (
      <Container className="py-5">
        <Alert variant="warning">Course data is unavailable.</Alert>
      </Container>
    );
  }

  return (
    <Container className="py-4">
      <FlashcardSession course={course} progress={progress} />
    </Container>
  );
}

export function FlashcardsPage() {
  const { courseId } = useParams();
  const { user } = useAuth();

  if (!user) {
    return (
      <Container className="py-5">
        <Alert variant="warning">Please log in to access courses.</Alert>
      </Container>
    );
  }

  if (!canViewCourse(user, courseId)) {
    return (
      <Container className="py-5">
        <Alert variant="danger">Access denied: You do not have access to this course.</Alert>
      </Container>
    );
  }

  return (
    <CourseProvider courseId={courseId}>
      <ProgressProvider courseId={courseId}>
        <FlashcardsContent />
      </ProgressProvider>
    </CourseProvider>
  );
}
